import axios from "axios";

import { GENERAL_URL_API } from "../../../urls";

/**
 * @param {string} id - id del formulario a eliminar
 * @returns {Promise<{info: string, status: boolean}>}
 */
export async function eliminarFormulario(id) {
  const fd = new FormData();
  fd.append("idFormularioEvento", id);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/eventos/formularios/borrarFormularioEvento`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
}
